export default {
  wordCount: {
    passingCopy: {
      default:
        'There are {wordCount} words in your cover letter. Cover letters should be between 150-300 words.',
    },
    failingCopy: {
      default:
        'There are {wordCount} words in your cover letter, which is over the suggested 350 word count or under the minimum of 150 words.',
      min: 'There are {wordCount} words in your cover letter, which is under the recommended 150 word minimum. Consider adding more details to your cover letter',
      max: 'There are {wordCount} words in your cover letter, which is over the recommended 350 word maximum. If you are not applying to executive-level, academic positions, consider reducing your cover letter length to under 350 words.',
    },
    title: 'Word count',
    groupTitle: 'Word count',
    label: 'Word count',
  },
  contactInformation: {
    title: 'Contact information',
    groupTitle: 'Contact information',
    label: 'Contact information',
  },
  phone: {
    passingCopy: {
      default: 'We found your phone number.',
    },
    failingCopy: {
      default:
        "We couldn't find a phone number in your cover letter. Please make sure you include your phone number so recruiters can follow up with you.",
    },
    title: 'Phone number',
    groupTitle: 'Contact information',
    label: 'Phone number',
  },
  email: {
    passingCopy: {
      default: 'We found your email.',
    },
    failingCopy: {
      default:
        "We couldn't find an email address in your cover letter. Please make sure you include your email so recruiters can follow up with you.",
    },
    title: 'Contact email',
    groupTitle: 'Contact information',
    label: 'Contact email',
  },
  contactAddress: {
    passingCopy: {
      default: 'We found your address.',
    },
    failingCopy: {
      default:
        "We couldn't find an address in your cover letter. Please make sure you include your address so recruiters can follow up with you.",
    },
    title: 'Contact address',
    groupTitle: 'Contact information',
    label: 'Contact address',
  },
  companyInformation: {
    title: 'Company information',
    groupTitle: 'Company information',
    label: 'Company information',
  },
  companyAddress: {
    passingCopy: {
      default: 'We found your address.',
    },
    failingCopy: {
      default:
        "We couldn't find an address in your cover letter. Please make sure you include your address so recruiters can follow up with you.",
    },
    title: 'Company address',
    groupTitle: 'Company information',
    label: 'Company address',
  },
  jobTitle: {
    passingCopy: {
      default: "We found the job title '{jobTitle}' in your cover letter.",
    },
    failingCopy: {
      default:
        "We couldn't find the job title '{jobTitle}' in your cover letter",
    },
    title: 'Job title',
    groupTitle: 'JobTitle',
    label: 'Job title',
  },
  companyName: {
    passingCopy: {
      default:
        "We found the company name '{companyName}' in your cover letter.",
    },
    failingCopy: {
      default:
        "We couldn't find the company name '{companyName}' in your cover letter.",
    },
    title: 'Company name',
    groupTitle: 'Company name',
    label: 'Company name',
  },
  measurableResults: {
    passingCopy: {
      default:
        'Three or more measurable results were found in your cover letter. Keep it up - employers like to see the impact and results that you had on the job.',
    },
    failingCopy: {
      default:
        'We found {measurableResultsCount} mentions of measurable results in your cover letter. Consider adding at least 3 specific achievements or impact you had in your job (e.g. time saved, increase in sales, etc).',
    },
    title: 'Measurable results',
    groupTitle: 'Measurable results',
    label: 'Measurable results',
  },
  coverLetterTone: {
    passingCopy: {
      default:
        'The tone of your cover letter is generally positive and no common cliches and buzzwords were found. Good job!',
    },
    failingCopy: {
      default:
        "We've found some negative phrases or cliches in your cover letter",
      negativeWords:
        "We've found some negative phrases or cliches in your cover letter:",
      negativeSentiment:
        'The tone of your cover letter is generally negative. Please consider using more positive words to reinforce your achievements.',
    },
    title: 'Words to avoid',
    groupTitle: 'Words to avoid',
    label: 'Words to avoid',
  },
}
